/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Commission_RateInputs */

const es_l6_commission_rate = /** @type {(inputs: L6_Commission_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% + IVA`)
};

const gl_l6_commission_rate = /** @type {(inputs: L6_Commission_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% + IVE`)
};

const en_l6_commission_rate = /** @type {(inputs: L6_Commission_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`15% + VAT`)
};

/**
* | output |
* | --- |
* | "15% + VAT" |
*
* @param {L6_Commission_RateInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_commission_rate = /** @type {((inputs?: L6_Commission_RateInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Commission_RateInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_commission_rate(inputs)
	if (locale === "en") return en_l6_commission_rate(inputs)
	return es_l6_commission_rate(inputs)
});